import styled from 'styled-components';
import { IconButton, Text } from '@perch-labs/shrike';

export const StyledIconButton = styled(IconButton)<StyleProps>`
  position: absolute;
  right: 20px;
  top: 20px;
`;

// max-width to accommodate dismiss button
export const StyledText = styled(Text)`
  max-width: calc(100% - 38px);
`;
